const Spinner = () => <svg className="spinner" viewBox="0 0 48 48">
    <circle className="spinner--circle--background" stroke="white" strokeWidth="6" fill="transparent" r="20" cx="24" cy="24" />
    <circle className="spinner--circle" stroke="white" strokeWidth="8" fill="transparent" r="20" cx="24" cy="24" />
  </svg>;
export default Spinner;